<template>
  <div
    v-if="order.fulfillment_status === FULFILLMENT_STATUS.bagged"
    class="bg-green-200 rounded-lg py-4 text-lg text-center text-green-400 font-semibold flex items-center justify-center gap-1"
  >
    <CheckCircleIcon class="w-7 h-7 text-green-500" />
    Fulfilled
  </div>
  <!-- Order is cancelled and has been finalized -->
  <div
    v-else-if="order.fulfillment_status === FULFILLMENT_STATUS.cancelled && !order.needs_packed_at"
    class="bg-red-200 rounded-lg py-4 text-lg text-center text-red-400 font-semibold flex items-center justify-center gap-1"
  >
    <XCircleIcon class="w-7 h-7 text-red-500" />
    Cancellation Finalized
  </div>
  <Menu
    v-else-if="order.status !== FULFILLMENT_STATUS.cancelled"
    as="div"
    class="relative"
    v-slot="{ open }"
  >
    <div class="flex">
      <button
        type="button"
        :disabled="!canComplete"
        @click="emit('complete')"
        class="btn btn-primary rounded-r-none py-4 text-lg flex-1"
        :class="{ 'rounded-b-none': open, 'cursor-not-allowed': !canComplete }"
      >
        Fulfill Order
      </button>
      <MenuButton
        :disabled="!canComplete"
        class="bg-blue-600 rounded-lg px-6 rounded-l-none border-l"
        :class="{
          'rounded-b-none': open,
          'bg-gray-600 cursor-not-allowed': !canComplete,
          'border-navy-600': canComplete
        }"
      >
        <ChevronUpIcon
          v-if="open"
          class="w-4 h-4 text-gray-100"
        />
        <ChevronDownIcon
          v-else
          class="w-4 h-4 text-gray-100"
        />
      </MenuButton>
    </div>
    <MenuItems
      class="absolute top-full w-full bg-blue-600 text-gray-100 rounded-lg rounded-t-none flex flex-col divide-y divide-navy-600 border-t border-navy-600 overflow-hidden"
    >
      <MenuItem class="py-4 px-5 hover:bg-blue-400">
        <button
          type="button"
          class="text-left"
          @click="emit('complete-and-notify')"
        >
          Fulfill Order + Notify
        </button>
      </MenuItem>
    </MenuItems>
  </Menu>
  <Menu
    v-else
    as="div"
    class="relative"
    v-slot="{ open }"
  >
    <div class="flex">
      <button
        type="button"
        :disabled="!canComplete"
        @click="emit('finalize-cancel')"
        class="btn bg-red-400 border-0 text-gray-100 rounded-r-none py-4 text-lg flex-1"
        :class="{ 'rounded-b-none': open, 'cursor-not-allowed': !canComplete }"
      >
        Finalize Cancellation
      </button>
      <MenuButton
        :disabled="!canComplete"
        class="bg-red-400 rounded-lg px-6 rounded-l-none border-l"
        :class="{
          'rounded-b-none': open,
          'bg-gray-600 cursor-not-allowed': !canComplete,
          'border-red-600': canComplete
        }"
      >
        <ChevronUpIcon
          v-if="open"
          class="w-4 h-4 text-gray-100"
        />
        <ChevronDownIcon
          v-else
          class="w-4 h-4 text-gray-100"
        />
      </MenuButton>
    </div>
    <MenuItems
      class="absolute top-full w-full bg-red-400 text-gray-100 rounded-lg rounded-t-none flex flex-col divide-y divide-red-600 border-t border-red-600 overflow-hidden"
    >
      <MenuItem class="py-4 px-5 hover:bg-red-400">
        <button
          type="button"
          class="text-left"
          @click="emit('finalize-cancel-and-notify')"
        >
          Finalize Cancellation + Notify
        </button>
      </MenuItem>
    </MenuItems>
  </Menu>
</template>

<script setup>
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import { ChevronDownIcon, ChevronUpIcon, CheckCircleIcon, XCircleIcon } from '@heroicons-2/vue/24/outline'
import { FULFILLMENT_STATUS } from '../../Composables/Fulfillment/constants'

const emit = defineEmits(['complete', 'complete-and-notify', 'finalize-cancel', 'finalize-cancel-and-notify'])

const props = defineProps({
  order: {
    type: Object,
    required: true
  },
  canComplete: {
    type: Boolean,
    required: true
  }
})
</script>
